import {
  GlobalCard,
  GlobalCardBody,
  GlobalCardHeader,
  GlobalCardHeaderCollapsible,
} from '@global-engineering-shared/gweb-material-global';
import { Box, Divider } from '@global-engineering-shared/gweb-material-ui';
import { ReactElement, useState } from 'react';

import useStyles from 'components/DetailsCard/DetailsCard.styles';

type DetailsCardProps = {
  title: string;
  detailsRows: ReactElement[];
  expanded?: boolean;
};

const DetailsCard = ({ title, detailsRows, expanded = true }: DetailsCardProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const classes = useStyles();

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <GlobalCard>
      <GlobalCardHeader>
        <Box>
          <GlobalCardHeaderCollapsible onOpen={toggleExpand} open={isExpanded} />
          <span className={classes.header}>{title.toUpperCase()}</span>
        </Box>
      </GlobalCardHeader>
      <GlobalCardBody>
        {isExpanded && (
          <Box className={classes.card}>
            <Divider className={classes.titleDivider} data-testid="title-divider" />
            {detailsRows.map((detailRow, index) => {
              return (
                <div key={index}>
                  {detailRow}
                  {detailsRows.indexOf(detailRow) < detailsRows.length - 1 && (
                    <Divider className={classes.rowDivider} data-testid="row-divider" />
                  )}
                </div>
              );
            })}
          </Box>
        )}
      </GlobalCardBody>
    </GlobalCard>
  );
};

export default DetailsCard;
